import React from 'react';
import {
  PROJECT_STATUS_CLASSES,
  PROJECT_STATUS_LABELS,
  ProjectStatus,
} from './projectUtils';

interface ProjectStatusPillProps {
  status: ProjectStatus;
  className?: string;
}

export const ProjectStatusPill: React.FC<ProjectStatusPillProps> = ({
  status,
  className = '',
}) => {
  const cls = PROJECT_STATUS_CLASSES[status] || PROJECT_STATUS_CLASSES.ACTIVE;
  const label = PROJECT_STATUS_LABELS[status] || status;
  return (
    <span
      className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-semibold ${cls} ${className}`}
    >
      {label}
    </span>
  );
};
